new Swiper('.slider-image-url__slider .swiper:not(.swiper-initialized)', {
    speed: 400,
    spaceBetween: 2,
    breakpoints: {
        0: {
            slidesPerView: 1.2
        },
        768: {
            slidesPerView: 2.5
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 2,
            height: 450
        }
    }
});

window.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('.slider-image-url__slider')!= null){
        document.querySelector('.slider-image-url__slider').addEventListener('click', function (e) {
            if(e.target.closest('.slide-cta__point')){
                e.target.closest('.slide-cta__point').classList.add('active');
                e.target.closest('.slide-cta').querySelector('.slide-cta__box').classList.add('active');
            }else if(!e.target.closest('.slide-cta__point') && e.target.closest('.swiper-slide')){
                e.target.closest('.swiper-slide').querySelector('.slide-cta__point').classList.remove('active');
                e.target.closest('.swiper-slide').querySelector('.slide-cta__box').classList.remove('active');
            }
        })
    }
});
